import { GroupId } from '../../typings/groups';
import { EditPageBackToFrontErrorMapper } from '../EditPageBackToFrontErrorMapper/EditPageBackToFrontErrorMapper';

import { groupsTextErrorMapper } from './GroupEditErrorsTextMapper/GroupEditErrorsTextMapper';

const INDEX = '__INDEX__';

export const createTextGroupUpdateHandleErrorMapper = (
    groupIds: Array<GroupId>
): EditPageBackToFrontErrorMapper =>
    new EditPageBackToFrontErrorMapper(
        'groups',
        {
            updateAdGroupItems: [
                {
                    serverPath: ['adGroupName'],
                    clientPath: ['name']
                },
                {
                    serverPath: ['adGroupMinusKeywords'],
                    clientPath: ['minusKeywords']
                },
                {
                    serverPath: ['adGroupMinusKeywords', INDEX],
                    clientPath: ['minusKeywords']
                },
                {
                    serverPath: ['keywords', INDEX, 'phrase'],
                    clientPath: ['keywords']
                },
                {
                    serverPath: ['keywords', INDEX],
                    clientPath: ['keywords']
                },
                {
                    serverPath: ['regionIds'],
                    clientPath: ['regionIds']
                },
                {
                    serverPath: ['libraryMinusKeywordsIds', INDEX],
                    clientPath: ['libraryMinusKeywordsIds']
                },
                {
                    serverPath: ['targetInterests', INDEX],
                    clientPath: ['retargeting']
                },
                {
                    serverPath: [
                        'targetInterests',
                        INDEX,
                        'retargetingConditionId'
                    ],
                    clientPath: ['retargeting']
                }
            ]
        },
        groupIds,
        groupsTextErrorMapper,
        INDEX
    );

export const createSmartGroupUpdateHandleErrorMapper = (
    groupIds: Array<GroupId>
): EditPageBackToFrontErrorMapper =>
    new EditPageBackToFrontErrorMapper(
        'groups',
        {
            updateItems: [
                {
                    serverPath: ['adGroupName'],
                    clientPath: ['name']
                },
                {
                    serverPath: ['minusKeywords'],
                    clientPath: ['minusKeywords']
                },
                {
                    serverPath: ['minusKeywords', INDEX],
                    clientPath: ['minusKeywords']
                },
                {
                    serverPath: ['regionIds'],
                    clientPath: ['regionIds']
                },
                {
                    serverPath: ['level'],
                    clientPath: ['level']
                }
            ]
        },
        groupIds,
        groupsTextErrorMapper,
        INDEX
    );

export const createSmartGroupAddHandleErrorMapper = (
    groupId: GroupId
): EditPageBackToFrontErrorMapper =>
    new EditPageBackToFrontErrorMapper(
        'groups',
        {
            addItems: [
                {
                    serverPath: ['adGroupName'],
                    clientPath: ['name']
                },
                {
                    serverPath: ['feedId'],
                    clientPath: ['feedId']
                }
            ]
        },
        [groupId],
        groupsTextErrorMapper,
        INDEX
    );

export const createCpmGroupUpdateHandleErrorMapper = (
    groupIds: Array<GroupId>
): EditPageBackToFrontErrorMapper =>
    new EditPageBackToFrontErrorMapper(
        'groups',
        {
            updateCpmAdGroupItems: [
                {
                    serverPath: ['adGroupName'],
                    clientPath: ['name']
                },
                {
                    serverPath: ['pageBlocks'],
                    clientPath: ['pageBlocks']
                },
                {
                    serverPath: ['pageBlocks', INDEX, 'pageId'],
                    clientPath: ['pageBlocks']
                },
                {
                    serverPath: ['adGroupMinusKeywords'],
                    clientPath: ['minusKeywords']
                },
                {
                    serverPath: ['adGroupMinusKeywords', INDEX],
                    clientPath: ['minusKeywords']
                },
                {
                    serverPath: ['keywords', INDEX, 'phrase'],
                    clientPath: ['keywords']
                },
                {
                    serverPath: ['keywords', INDEX],
                    clientPath: ['keywords']
                },
                {
                    serverPath: ['keywords'],
                    clientPath: ['keywords']
                },
                {
                    serverPath: ['regionIds'],
                    clientPath: ['regionIds']
                },
                {
                    serverPath: ['libraryMinusKeywordsIds'],
                    clientPath: ['libraryMinusKeywordsIds']
                },
                {
                    serverPath: ['targetInterests', INDEX],
                    clientPath: ['retargeting']
                },
                {
                    serverPath: [
                        'targetInterests',
                        INDEX,
                        'retargetingConditionId'
                    ],
                    clientPath: ['retargeting']
                },
                {
                    serverPath: ['retargetingCondition', 'name'],
                    clientPath: ['retargetingConditionName']
                },
                {
                    serverPath: [
                        'retargetingCondition',
                        'conditionRules',
                        INDEX,
                        'goals',
                        INDEX,
                        'id'
                    ],
                    clientPath: ['retargetingCondition']
                },
                {
                    serverPath: ['retargetingCondition', 'conditionRules'],
                    clientPath: ['retargetingCondition']
                },
                {
                    serverPath: ['generalPrice'],
                    clientPath: ['generalRate']
                }
            ]
        },
        groupIds,
        groupsTextErrorMapper,
        INDEX
    );

export const createInternalGroupUpdateHandleErrorMapper = (
    groupIds: Array<GroupId>
): EditPageBackToFrontErrorMapper =>
    new EditPageBackToFrontErrorMapper(
        'groups',
        {
            updateItems: [
                {
                    serverPath: ['adGroupName'],
                    clientPath: ['name']
                },
                {
                    serverPath: ['name'],
                    clientPath: ['name']
                },
                {
                    serverPath: ['adGroupMinusKeywords'],
                    clientPath: ['minusKeywords']
                },
                {
                    serverPath: ['adGroupMinusKeywords', INDEX],
                    clientPath: ['minusKeywords']
                },
                {
                    serverPath: ['regionIds'],
                    clientPath: ['regionIds']
                },
                {
                    serverPath: ['targetingYandexUids', 'value'],
                    clientPath: ['targetingYandexUids']
                },
                {
                    serverPath: ['level'],
                    clientPath: ['level']
                }
            ]
        },
        groupIds,
        groupsTextErrorMapper,
        INDEX
    );

export const createInternalGroupAddHandleErrorMapper = (
    groupIds: Array<GroupId>
): EditPageBackToFrontErrorMapper =>
    new EditPageBackToFrontErrorMapper(
        'groups',
        {
            addItems: [
                {
                    serverPath: ['name'],
                    clientPath: ['name']
                },
                {
                    serverPath: ['regionIds'],
                    clientPath: ['regionIds']
                },
                {
                    serverPath: ['targetingYandexUids', 'value'],
                    clientPath: ['targetingYandexUids']
                },
                {
                    serverPath: ['level'],
                    clientPath: ['level']
                }
            ]
        },
        groupIds,
        groupsTextErrorMapper,
        INDEX
    );
